/**
 * RC Pre-login siteidentifier
 */
const dservice = "dservice";
/**
 * RC Post-login siteidentifier for Desktop devices
 */
const eservice = "eservice";
/**
 * RC Post-login siteidentifier for Mobile devices
 */
const mservice = "mservice";
/**
 * RC Paypal Post-login siteidentifier
 */
const eservice_ess = "eservice_ess";
/**
 * RC Paypal mobile post-login siteidentifier
 */
const mservice_mss = "mservice_mss";
/**
 * bank Site identifier
 */
const bank = "bank";
export function getSiteIdentifier() {
    return window._SFDDL && window._SFDDL.pageInfo && window._SFDDL.pageInfo.SiteIdentifier && window._SFDDL.pageInfo.SiteIdentifier.toLowerCase();
}
export function getBaseSessionId() {
    return window._SFDDL && window._SFDDL.base && window._SFDDL.base.session_id;
}
export function isRC() {
    const siteIdentifier = getSiteIdentifier();
    return (siteIdentifier === mservice_mss
        || siteIdentifier === eservice_ess
        || siteIdentifier === mservice
        || siteIdentifier === eservice
        || siteIdentifier === dservice);
}
export function isRCLoggedIn() {
    const siteIdentifier = getSiteIdentifier();
    return (siteIdentifier === mservice_mss || siteIdentifier === eservice_ess || siteIdentifier === mservice || siteIdentifier === eservice);
}
export function isRCPostLoginMobile() {
    const siteIdentifier = getSiteIdentifier();
    return siteIdentifier === mservice;
}
export function isCBPlatform() {
    const siteIdentifier = getSiteIdentifier();
    return siteIdentifier === bank;
}
